import { Link } from 'react-router-dom'
import Logo from '../icons/logo.svg'
import LogoBlanco from '../icons/logo_transparente_blanco.png'
import moment from 'moment'

const displayTime = (t) => {
  if (t) {
    let list = t.split(':')
    return parseInt(list[0], 10) + ':' + list[1] + 'h'
  }
  return null
}

const EventoCard = ({ evento }) => {
  const fechaInicio = moment(
    `${evento.fecha_inicio} ${evento.hora_inicio || '00:00:00'}`,
    'YYYY-MM-DD HH:mm:ss'
  );
  const ahora = moment();
  const esHoy = ahora.isSame(fechaInicio, 'day');
  const esFuturo = ahora.isBefore(fechaInicio, 'day');
  const yaPaso = ahora.isAfter(moment(fechaInicio).endOf('day'));

  let estadoBadge = { texto: 'Próximo', clase: 'bg-blue-100 text-blue-700' };
  if (esHoy) {
    estadoBadge = { texto: 'Hoy', clase: 'bg-green-100 text-green-700' };
  } else if (esFuturo) {
    estadoBadge = { texto: 'Próximo', clase: 'bg-blue-100 text-blue-700' };
  } else if (yaPaso) {
    estadoBadge = { texto: 'Pasado', clase: 'bg-gray-100 text-gray-700' };
  }

  const inner = (
    <>
      <div className="text-2xl font-montserrat font-semibold italic text-gray-900 mb-5 leading-tight">
        {evento.nombre}
      </div>
      <div className="flex items-center gap-3">
        <span className={`px-3 py-1 ${estadoBadge.clase} font-montserrat font-light text-xs rounded-full uppercase flex items-center gap-1`}>
          {estadoBadge.texto === 'En vivo' && (
            <span className="animate-pulse-fast">●</span>
          )}
          {estadoBadge.texto}
        </span>
        <span className="text-sm text-gray-600 font-montserrat">
          {moment(evento.fecha_inicio).format('DD/MM/YYYY')}
        </span>
        <span className="text-sm font-semibold text-gray-700 font-montserrat">
          {displayTime(evento.hora_inicio)}
        </span>
      </div>
    </>
  );

  if (evento._href) {
    return <a href={evento._href} className="block p-6">{inner}</a>;
  }
  return <Link to={`/${evento.id}`} className="block p-6">{inner}</Link>;
}

const EventoList = (props) => (
  <div className="min-h-screen flex flex-col">
    <div className="flex-grow px-5 py-6 max-w-4xl mx-auto w-full">
      <a href="https://resultados.live" className="flex justify-center mb-8">
        <img src={Logo} alt="Logo ChampionChipNorte Live" className="h-16" />
      </a>

      <ul className="space-y-4 list-none m-0">
        {props.eventos.map(evento => (
          <li
            key={evento._href ? `live2-${evento.id}` : evento.id}
            className="bg-white rounded-xl shadow-lg hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 border-l-4 border-ccnorte"
          >
            <EventoCard evento={evento} />
          </li>
        ))}
      </ul>

      <div className="mt-12 text-left">
        <a
          href="https://ccnorte.com/evento/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-ccnorte italic hover:underline uppercase font-montserrat inline-flex items-center gap-1"
        >
          Apúntate en CCNorte.com ↗
        </a>
      </div>
    </div>

    <div className="bg-gray-900 py-6 flex justify-center">
      <img
        src={LogoBlanco}
        alt="ChampionChipNorte"
        className="h-12 opacity-90 hover:opacity-100 transition-opacity duration-300"
      />
    </div>
  </div>
)

export default EventoList
